<div>
  <app-flashcard-widget *ngFor="let flashcard of flashcards" [flashcard]="flashcard" [hideDueDate]="hideDueDate" (actionClicked)="handleActionClicked($event, flashcard)"></app-flashcard-widget>
</div>